import data from "../../../../../src/drafts/InlineAutocomplete/InlineAutocomplete.docs.json";
import * as React from 'react';
export default {
  data,
  React
};